import { MaintenanceModules } from "@/constants/enums";

/**
 * Mapeo de códigos de módulos a etiquetas legibles.
 */
const moduleLabels: Record<string, string> = {
  [MaintenanceModules.General]: "General",
  [MaintenanceModules.Finanzas]: "Finanzas",
  [MaintenanceModules.Granaria]: "Granos",
  [MaintenanceModules.Insumos]: "Insumos",
  [MaintenanceModules.MercadoDelDia]: "Mercado del día",
  [MaintenanceModules.Otros]: "Otros",
  [MaintenanceModules.Onboarding]: "Onboarding",
  [MaintenanceModules.ProduccionAta]: "Producción ATA",
  [MaintenanceModules.ProduccionRSATYG]: "Producción RSATyG"
};

/**
 * Mapeo de códigos de secciones a etiquetas legibles.
 */
const sectionLabels: Record<string, string> = {
  GENERAL_APP: "App General",
  GENERAL: "General",

  CASH: "Efectivo",
  CHECK: "Cheques",
  TRANSFER: "Transferencias",
  FINANCIAL_MOVEMENTS: "Movimientos Financieros",
  EXTERNAL_TRANSFER: "Transferencias Externas",

  SLOTS: "Cupos",
  SALES: "Ventas",
  SELL_ORDER: "Orden de Venta",
  CASH_ON_DELIVERY: "Contra Entrega",
  FUTURE_CONTRACTS: "Contrato Futuro",

  PRICE_BOARD: "Precio Pizarra",
  UNION_MARKET: "Precios Mercado",

  USER_PROFILE: "Perfil de usuario",
  NOTIFICATIONS: "Notificaciones",
  SIDEBAR: "Sidebar",
  ENABLE_CVU: "CVU",
  CVU_REFUND: "Reintegro de saldo CVU",

  JURIDIC_ONB: "Persona Jurídica",

  FERTILIZER_SLOTS: "Cupos de fertilizante",
  FUEL_SLOTS: "Cupos de combustible",
  PURCHASE_INTENT: "Intención de compra",
  INVOICES: "Remitos y facturas",

  FIELD_VISIT: "Visita a Campo",
  PRODUCT_PLANIFICATION: "Planificacion productiva",

  SAMPLING: "Solicitudes de muestreo",
  FLIGHT: "Solicitudes de vuelo",
  ESTABLISHMENTS_LOTS: "Gestión de Establecimientos y Lotes",
  VOLEO: "Solicitudes de fertilización",
  GROSS_MARGIN: "Margen Bruto"
};


/**
 * Obtiene la etiqueta legible para un módulo.
 * @param moduleCode Código del módulo.
 * @returns Etiqueta legible del módulo.
 */
export const getModuleLabel = (moduleCode: string) => moduleLabels[moduleCode] ?? moduleCode;

/**
 * Obtiene la etiqueta legible para una sección.
 * @param sectionCode Código de la sección.
 * @returns Etiqueta legible de la sección.
 */
export const getSectionLabel = (sectionCode: string) => sectionLabels[sectionCode] ?? sectionCode;

/**
 * Tipo de objeto que representa una sección.
 */
export type SectionMap = Record<string, boolean>;

